var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4867_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4.675C25 3.375 24.5417 2.275 23.625 1.375C22.7083 0.475 21.6 0.0166664 20.3 0H4.675C3.39167 0 2.29167 0.458334 1.375 1.375C0.458334 2.29167 0 3.39167 0 4.675V20.3C0 21.6 0.458334 22.7083 1.375 23.625C2.29167 24.5417 3.39167 25 4.675 25H20.3C21.6 25 22.7083 24.5417 23.625 23.625C24.5417 22.7083 25 21.6 25 20.3V17.175H21.875V20.3C21.875 20.7333 21.725 21.1 21.425 21.4C21.125 21.7 20.75 21.8583 20.3 21.875H4.675C4.25833 21.875 3.89167 21.7167 3.575 21.4C3.25833 21.0833 3.10833 20.7167 3.125 20.3V4.675C3.125 4.24167 3.275 3.875 3.575 3.575C3.875 3.275 4.24167 3.125 4.675 3.125H20.3C20.7333 3.125 21.1083 3.275 21.425 3.575C21.7417 3.875 21.8917 4.24167 21.875 4.675V7.8H25V4.675ZM25 10.925H18.75V7.8L12.5 12.5L18.75 17.175V14.05H25V10.925Z",
    fill: "#399E79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4867_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "matrix(-1 0 0 -1 25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/checkOut.997441fcdabb63115d378e9c266aebe9.svg";
export { ForwardRef as ReactComponent };